<script setup>
defineProps({
    label: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: ''
    },
    activatorProps: {
        type: Object,
        default: () => ({})
    },
    className: {
        type: String,
        default: 'add-new-btn'
    }
})
</script>

<template>
    <v-btn type="submit" v-bind="activatorProps" :class="className" class="button-advanced-filter btn btn-primary p-0 m-0">
        <i style="color: #3c3c3c" class="material-symbols-outlined me-1">filter_list</i>
        <span style="color: #3c3c3c" class="d-none d-lg-inline">{{ label ?? $t('common.labels.advancedFilters') }}</span>
    </v-btn>
</template>


<style lang="scss" scoped>
.trezo-card{
    margin-bottom: -15px;

    button,
    a {
        text-transform: none!important;
        margin: {
            right: 15px;
            bottom: 15px;
        }
        display: inline-block !important;
        padding: 8px 20px !important;
        width: auto;
        height: auto;

        &.v-btn--icon {
            width: 56px;
            height: 56px;
            padding: 0 !important;
            color: var(--whiteColor);
        }
        &.trezo {
            color: var(--primaryColor);
        }

        &.d-block {
            text-align: center !important;
            display: block !important;
            width: 100% !important;
        }
    }
    button i {
        font-size: 22px;
    }
}
</style>
